<template>
<v-dialog v-model="show" :persistent="pers" :width="width" :dark="darkmode">
    <v-card :dark="darkmode">
        <v-card-title style="backgroundj:#f5f5f5;font-weight:bold">
            {{title}}

            <v-spacer></v-spacer>
            <slot name="header-actions">

            </slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
             <slot name="content">

            </slot>
        </v-card-text>
        <v-card-actions>
             <v-spacer></v-spacer>
             <slot name="footer-actions">

            </slot>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name:'dialog',
    props:{
        title:String,
        width:{
            type:String,
            default:"70%",
        },
        show:{
            type:Boolean,
            default:false,
        },
        pers:{
            type:Boolean,
            default:true,
        }

    },
     computed: {
    ...mapGetters({
      darkmode:"settings/DARKMODE"
    }),

  },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal.vue